import { Component } from "react";
import PropTypes from "prop-types";
import lodashGet from "lodash.get";
import AnalyticsContext, { dispatchAnalyticsEvent } from "../analytics-context";

class GenericPageView extends Component {
  constructor(props) {
    super(props);

    this.state = {
      ddlIsDirty: undefined,
      dtmIsReady: false,
      pageName: undefined
    };
  }

  componentDidUpdate() {
    if (
      this.context.ddlIsDirty !== this.state.ddlIsDirty ||
      this.context.dtmIsReady !== this.state.dtmIsReady ||
      this.state.pageName !== this.context.digitalData.pageName
    ) {
      this.setState(
        {
          ddlIsDirty: this.context.ddlIsDirty,
          dtmIsReady: this.context.dtmIsReady,
          pageName: this.context.digitalData.pageName
        },
        this.dispatchPageEvent
      );
    }
  }

  dispatchPageEvent = () => {
    const eventName = "generic-page-view";

    const { document, details } = this.props;

    const hasPageName =
      this.context.digitalData.pageName &&
      this.context.digitalData.pageName.length > 0;

    if (this.state.dtmIsReady && !this.state.ddlIsDirty && hasPageName) {
      dispatchAnalyticsEvent(document, eventName, details);
    }
  };

  render() {
    return null;
  }
}

GenericPageView.contextType = AnalyticsContext;

GenericPageView.propTypes = {
  eventName: PropTypes.string,
  details: PropTypes.object,
  document: PropTypes.object
};

GenericPageView.defaultProps = {
  document: lodashGet(global, "document", null),
  details: {}
};

export default GenericPageView;
